import * as Constants from '../../constants';

import { useState, useEffect, useCallback } from 'react';

import classes from "./ETFsList.module.css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExternalLink } from "@fortawesome/free-solid-svg-icons";
import { faFilter } from '@fortawesome/free-solid-svg-icons';

import Table from 'react-bootstrap/Table';
import Button from 'react-bootstrap/Button';

import ScrollContainer from '../../components/UI/ScrollContainer';
import Card from '../../components/UI/Card';

import Loading from '../../components/UI/Loading';
import ETFsFilterForm from '../../components/ETFsFilterForm';

const usdFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  useGrouping: false
});

const percentageFormatter = new Intl.NumberFormat('pt-BR', {
  style: 'percent',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
});

function ETFsList(props) {
  const [isLoading, setIsLoading] = useState(true);
  const [etfs, setETFs] = useState([]);
  const [filters, setFilters] = useState([]);
  const [filtersText, setFiltersText] = useState("");
  const [etfsFiltrados, setETFsFiltrados] = useState([]);
  const [filterFormIsShown, setFilterFormIsShown] = useState(false);
  const [lastUpdate, setLastUpdate] = useState("");

  const fetchETFsHandler = useCallback(async () => {
    setIsLoading(true);
    try {
      const lastUpdateReponse = await fetch(Constants.PUBLIC_ETFS_LAST_UPDATE);
      const lastUpdateData = await lastUpdateReponse.json();
      setLastUpdate(lastUpdateData);

      const response = await fetch(Constants.PUBLIC_ETFS_LIST);
      if (!response.ok) {
        alert('deu pau');
        throw new Error('Something went wrong!');
      }

      const data = await response.json();

      const loadedETFs = [];
      for (let item in data) {
        const element = data[item];
        let etf = {
          id: element.id,
          ticker: element.ticker,
          setor: element.sector,
          subsetor: element.subsector,
          price: element.currentPrice,
          expense: element.expense,
          earningYield: (!isNaN(element.pL) ? 1 / Number(element.pL) * 100 : ""),
          pL: element.pL,
          mgmt: (element.idx.length > 0 ? 2 : 1),
          idx: element.idx,
          pvp: element.pvp,
          dy: element.dy,
          vD: element.vD,
          vM: element.vM,
          vY: element.vY,
        }
        loadedETFs.push(etf);
      }
      console.warn(loadedETFs.length);
      setETFs(loadedETFs);
      setETFsFiltrados(loadedETFs);
    } catch (error) {
    }
    setIsLoading(false);
  }, []);

  useEffect(() => {
    fetchETFsHandler();
  }, [fetchETFsHandler]);

  useEffect(() => {
    if (etfs.length > 0)
      setIsLoading(false);
  }, [etfs]);

  useEffect(() => {
    let str = "";
    if (Object.keys(filters).length > 0) {
      str += '<strong style="color:#0A58CA">' + Object.keys(filters).length + ' filtros aplicados</strong>: ';
      str += (filters.codigo && filters.codigo.value && filters.codigo.value.length > 0 ? "<strong>Código</strong> contém '" + filters.codigo.value + "', " : "");
      str += (filters.setor && filters.setor.value && filters.setor.value.length > 0 ? "<strong>Setor</strong> contém '" + filters.setor.value + "', " : "");
      str += (filters.subsetor && filters.subsetor.value && filters.subsetor.value.length > 0 ? "<strong>Segmento:</strong> contém '" + filters.subsetor.value + "', " : "");
      str += "<br/>";
      str += (filters.expense && filters.expense.operator !== "" ? "<strong>Taxa de Administração</strong> " + filters.expense.operator + " " + filters.expense.value + "%, " : "");
      str += (filters.mgmt ? "<strong>Gestão</strong>: " + (filters.mgmt.value === 1 ? 'ATIVA' : 'PASSIVA') + ", " : "");
      str += (filters.idx && filters.idx.value && filters.idx.value.length > 0 ? "<strong>Índice</strong> contém '" + filters.idx.value + "', " : "");
      str += (filters.pvp && filters.pvp.operator !== "" ? "<strong>P/VP</strong> " + filters.pvp.operator + " " + filters.pvp.value + ", " : "");
      str += (filters.dy && filters.dy.operator !== "" ? "<strong>Dividend Yield</strong> " + filters.dy.operator + " " + filters.dy.value + "%, " : "");
      str += (filters.vD && filters.vD.operator !== "" ? "<strong>Variação 1Dia</strong> " + filters.vD.operator + " " + filters.vD.value + "%, " : "");
      str += (filters.vM && filters.vM.operator !== "" ? "<strong>Variação 1Mês</strong> " + filters.vM.operator + " " + filters.vM.value + "%, " : "");
      str += (filters.vY && filters.vY.operator !== "" ? "<strong>Variação 1Ano</strong> " + filters.vY.operator + " " + filters.vY.value + "%, " : "");
      str += (filters.price && filters.price.operator !== "" ? "<strong>Preço</strong> " + filters.price.operator + " R$ " + filters.price.value + ", " : "");
      str = str.substring(0, str.length - 2);
    }
    if (str.length === 0) str = "<br/><br/>";
    setFiltersText(str);
  }, [filters]);

  const showHideFilterFormHandler = () => {
    setFilterFormIsShown(!filterFormIsShown);
  };

  const closeFilterFormHandler = () => {
    setFilterFormIsShown(false);
  };


  const filtersHandler = (filters) => {
    setFilters(filters);
    setFilterFormIsShown(false);
    const filtered = etfs.filter(item => {
      return Object.keys(filters).every(key => {
        const filtroValor = filters[key]?.value;
        const filtroOperador = filters[key]?.operator;
        const itemValor = item[key];

        // Ignorar se o valor do filtro for undefined, vazio ou zero
        if (filtroValor === undefined || filtroValor === "" || filtroOperador === 0) {
          return true;
        }

        // Para valores string, realizar comparação parcial similar ao LIKE
        if (isNaN(itemValor) && (typeof itemValor === "string" && typeof filtroValor === "string")) {
          return itemValor.toLowerCase().includes(filtroValor.toLowerCase());
        } else {
          // console.warn(key, itemValor, filtroOperador, filtroValor);
          switch (filtroOperador) {
            case ">":
              return Number(itemValor) > Number(filtroValor);
            case ">=":
              return Number(itemValor) >= Number(filtroValor);
            case "<":
              return Number(itemValor) < Number(filtroValor);
            case "<=":
              return Number(itemValor) <= Number(filtroValor);
            case "=":
            default:
              return Number(itemValor) === Number(filtroValor);
          }
        }
      });

    });
    setETFsFiltrados(filtered);
  };

  const dataAtualFormatada = (dt) => {
    var data = new Date(dt);
    var dia = data.getDate().toString(),
      diaF = (dia.length === 1) ? '0' + dia : dia,
      mes = (data.getMonth() + 1).toString(), //+1 pois no getMonth Janeiro começa com zero.
      mesF = (mes.length === 1) ? '0' + mes : mes,
      anoF = data.getFullYear(),
      hora = (data.getHours().toString().length === 1) ? '0' + data.getHours() : data.getHours(),
      min = (data.getMinutes().toString().length === 1) ? '0' + data.getMinutes() : data.getMinutes(),
      seg = (data.getSeconds().toString().length === 1) ? '0' + data.getSeconds() : data.getSeconds();

    return diaF + "/" + mesF + "/" + anoF + " " + hora + ":" + min + ":" + seg;
  }

  return <>
    {isLoading && <Loading />}
    {!isLoading && <>
      <div className="row mainPanel">
        <div className="col col-md-12">
          <Card>
            {filterFormIsShown && <ETFsFilterForm
              updateFilters={filtersHandler}
              closeFilterForm={closeFilterFormHandler}
              filters={filters}
            />}
            <div className='row'>
              <div className='col-2'>
                <Button variant="secondary" className={classes.filterButton} onClick={showHideFilterFormHandler}><FontAwesomeIcon icon={faFilter} /></Button>
                &nbsp;&nbsp;
                <small>
                  <strong>{etfsFiltrados.length}</strong> ETFs encontrados.
                </small>
              </div>
              <div className='col'><small dangerouslySetInnerHTML={{ __html: filtersText }} /></div>
              <div className='col-2'>
                <small className='lastUpdate'><b>Última atualização:</b>&nbsp;&nbsp;{dataAtualFormatada(lastUpdate)}</small>
              </div>
            </div>
            <div className='row'>
              <div className='col-12'>
                <ScrollContainer>
                  <Table striped bordered hover>
                    <thead className={`fixedTableHead ${classes.fixedTableHead}`}>
                      <tr>
                        <th rowSpan="2" className='text-center'>CÓDIGO</th>
                        <th rowSpan="2">Setor<br /><small>Subsetor</small></th>
                        <th rowSpan="2" className={classes.th}>Liquidez<br />Diária</th>
                        <th rowSpan="2">P/L</th>
                        {/* <th rowSpan="2">Earning<br/>Yield</th> */}
                        <th rowSpan="2">Taxa de<br />Administração</th>
                        <th rowSpan="2">Tipo de<br />Gestão</th>
                        <th rowSpan="2">Índice</th>

                        {/* <th rowSpan="2">PVP</th> */}
                        <th colSpan="1" rowSpan="2">Dividend<br />Yield</th>
                        {/* <th rowSpan="2">Dividend<br />Yield</th> */}
                        {/* <th rowSpan="2">Último<br />Dividendo</th> */}
                        <th colSpan="3" className={classes.red4}>Variação</th>
                        <th colSpan="1" rowSpan="2">Preço<br />Atual</th>
                      </tr>
                      <tr>
                        {/* <th>YOC</th> */}
                        {/* <th colSpan="2">12 Meses</th> */}
                        {/* <th>1 Mês</th> */}
                        <th className={classes.red3}>1 Dia</th>
                        <th className={classes.red2}>1 Mês</th>
                        <th className={classes.red1}>1 Ano</th>
                      </tr>
                    </thead>
                    <tbody>
                      {etfs.length === 0 && <tr>
                        <td colSpan='20'>Nenhum ativo cadastrado.</td>
                      </tr>
                      }
                      {
                        etfsFiltrados.map((etf) => <tr key={etf.id}>
                          <td className={classes.td + " text-center"}>
                            <span className="font-weight-bolder">{etf.ticker}</span><br />
                            <a href={`${Constants.BASE_URL_EUA_ETF_STATUSINVEST}${etf.ticker}`} target='_blank' rel="noreferrer" title='StatusInvest'>
                              <FontAwesomeIcon icon={faExternalLink} />
                            </a>&nbsp;&nbsp;
                            <a href={`${Constants.BASE_URL_EUA_ETF_ETFDB}${etf.ticker}`} target='_blank' rel="noreferrer" title='etfdb'>
                              <FontAwesomeIcon icon={faExternalLink} />
                            </a>&nbsp;&nbsp;
                            <a href={`${Constants.BASE_URL_EUA_ETF_YAHOOFINANCE}${etf.ticker}`} target='_blank' rel="noreferrer" title='Yahoo! Finance'>
                              <FontAwesomeIcon icon={faExternalLink} />
                            </a>&nbsp;&nbsp;
                            <a href={`${Constants.BASE_URL_EUA_ETF_INVESTIDOR10}${etf.ticker}`} target='_blank' rel="noreferrer" title='Investidor10'>
                              <FontAwesomeIcon icon={faExternalLink} />
                            </a>
                          </td>
                          <td className={classes.td}>{etf.setor}<br /><small>{etf.subsetor}</small></td>
                          <td className={classes.td}><small>0</small></td>
                          <td className={classes.td}>{etf.pL !== '' && !isNaN(etf.pL) ? percentageFormatter.format(etf.pL / 100) : ""}</td>
                          {/* <td className={classes.td}>{etf.earningYield !== '' && !isNaN(etf.earningYield) ? percentageFormatter.format(etf.earningYield  / 100) : ""}</td>                                     */}
                          <td className={classes.td}>{etf.expense !== '' && !isNaN(etf.expense) ? percentageFormatter.format(etf.expense / 100) : ""}</td>
                          <td className={classes.td}>{etf.mgmt === 1 ? "ATIVA" : "PASSIVA"}</td>
                          <td className={classes.td}>{etf.idx}</td>
                          {/* <td className={classes.td}>divida </td> */}
                          {/* <td className={classes.td}>{acao.payout}%</td> */}
                          {/* <td className={classes.td + "" + (acao.pvp < 1 ? " text-success" : "")}>{acao.pvp.replace(".", ",")}</td> */}
                          <td className={classes.td}>{!isNaN(etf.dy) ? percentageFormatter.format(etf.dy / 100) : ""}</td>
                          <td className={classes.td + "" + (etf.vD < 0 ? " text-danger" : "")}>{etf.vD !== '' && !isNaN(etf.vD) ? percentageFormatter.format(etf.vD / 100) : ""}</td>
                          <td className={classes.td + "" + (etf.vM < 0 ? " text-danger" : "")}>{etf.vM !== '' && !isNaN(etf.vM) ? percentageFormatter.format(etf.vM / 100) : ""}</td>
                          {/* <td className={classes.td}>{acao.vYTD}%</td> */}
                          <td className={classes.td + "" + (etf.vY < 0 ? " text-danger" : "")}>{etf.vY !== '' && !isNaN(etf.vY) ? percentageFormatter.format(etf.vY / 100) : ""}</td>
                          {/* <td className={classes.td + (acao.price > acao.currentPrice ? " text-danger" : "")}>{brlFormatter.format(acao.price)}</td> */}
                          <td className={classes.td}>{etf.price !== '' && !isNaN(etf.price) ? usdFormatter.format(etf.price).replace('.', ',') : ""}</td>
                          {/* <td className={classes.td + (acao.valorInvestido > acao.valorAtual ? " text-danger" : "")}>{brlFormatter.format(acao.valorInvestido)}</td> */}
                          {/* <td className={classes.td}>{brlFormatter.format(acao.valorAtual)}</td> */}
                        </tr>
                        )
                      }
                    </tbody>
                  </Table>
                </ScrollContainer>
              </div>
            </div>
          </Card>
        </div>
      </div>
      <div className="row adPanel">
        <div className='col'>sdafads<br />sdafads<br />sdafads<br /></div>
      </div>
    </>
    }
  </>
}
export default ETFsList;
